import { render } from "./Receta.vue?vue&type=template&id=4e2c4282"
import script from "./Receta.vue?vue&type=script&lang=js"
export * from "./Receta.vue?vue&type=script&lang=js"
script.render = render

export default script